import { PostSource } from '../../../models/graphql';
import { GroupPostAttributesType, PostEditorState, PostGroupsType } from '../../../models/post-editor';
import { ImmutabilityContext } from '../states/effects/customImmutabilityContext';

export const setPostSource = (state: PostEditorState, source: PostSource): PostEditorState => {
  const { update: updateImmutable } = ImmutabilityContext;
  return updateImmutable(state, {
    postGroups: {
      $apply: (currentGroups: PostGroupsType[]) =>
        currentGroups.map(curentGroup =>
          updateImmutable<PostGroupsType>(curentGroup, {
            groupPostAttributes: {
              postSource: { $set: source }
            },
            posts: {
              $apply: (currentPosts: GroupPostAttributesType[]) =>
                currentPosts.map(post =>
                  updateImmutable(post, {
                    postSource: { $set: source }
                  })
                )
            }
          })
        )
    }
  });
};

export const getPostSourceFrom3rdPartySource = (
  platform: string,
  type: string | undefined,
  isBulk: boolean
): PostSource => {
  switch (platform) {
    case 'FACEBOOK':
      return isBulk ? PostSource.FACEBOOK_PAGE_BULK : PostSource.FACEBOOK_PAGE;
    case 'INSTAGRAM':
      return isBulk ? PostSource.INSTAGRAM_BULK : PostSource.INSTAGRAM;
    case 'LINKEDIN':
      return isBulk ? PostSource.LINKEDIN_BULK : PostSource.LINKEDIN;
    case 'PINTEREST':
      if (type && !['BOARD', 'PROFILE'].includes(type))
        throw new Error(
          `Third Party Pinterest Post type is neither "BOARD" nor "PROFILE". The received value ${type} is not allowed.`
        );
      if (type === 'BOARD') {
        return isBulk ? PostSource.PINTEREST_BOARD_BULK : PostSource.PINTEREST_BOARD;
      } else {
        return isBulk ? PostSource.PINTEREST_USER_BULK : PostSource.PINTEREST_USER;
      }
    case 'RSS':
      return isBulk ? PostSource.RSS_BULK : PostSource.RSS;
  }

  throw new Error(`Third party post ${platform} platform and ${type} type, cound not be mapped to PostSource type.`);
};
